import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/moving-box-shipping.jpg'),
    alt: 'moving box shipping page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'moving box shipping page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Moving <span>Box Shipping</span> <span>For Domestic and International</span>',
  description:
    "Moving shouldn't be stressful. With ShipAndStorage, shipping your boxes is simple, reliable, and affordable. ",

  image: {
    url: '/images/v2/pages/main-pages/moving-box-shipping/hero-image.jpg',
    alt: 'moving box shipping page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Shipping Now' }
}

export const whyWeSectionContent = {
  title: 'How to Book Your Shipment?',

  cards: [
    {
      id: 1,
      title: 'Book Online',
      description: 'Sign up and place your order via our pricing page.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/book-online.svg',
        alt: 'Book Online service'
      }
    },
    {
      id: 2,
      title: 'Label Your Box',
      description: 'Securely attach the shipping labels we provide by mail or email.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/label-your-box.png',
        alt: 'Label Your Box service'
      }
    },
    {
      id: 3,
      title: 'Pickup or Drop-Off',
      description: 'Schedule a pickup or drop your box off at a partner carrier location.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/pickup-or-drop-off.svg',
        alt: 'Pickup or Drop-Off service'
      }
    },
    {
      id: 4,
      title: 'Enjoy Delivery',
      description: 'Receive your box on time, securely delivered to your destination.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/enjoy-delivery.svg',
        alt: 'Enjoy Delivery service'
      }
    }
  ]
}

export const serviceTipsSectionSectionContent = {
  title: 'Why Choose Us for Moving Box Shipping?',

  cards: [
    {
      id: 1,
      title: 'Affordable Rates',
      description: 'Competitive pricing ensures you receive premium service without exceeding your budget.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/affordable-rates.svg',
        alt: 'Affordable Rates service'
      }
    },
    {
      id: 2,
      title: 'Pickup and Delivery',
      description: 'Schedule doorstep pickup or drop off your boxes at any of our nationwide locations.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/pickup-and-delivery.svg',
        alt: 'Pickup and Delivery service'
      }
    },
    {
      id: 3,
      title: 'Global Reach',
      description: 'Seamlessly ship your boxes to over 220 countries and territories around the globe.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/global-reach.svg',
        alt: 'Global Reach service'
      }
    },
    {
      id: 4,
      title: 'Real-Time Tracking',
      description: 'Stay updated with real-time tracking from initial pickup to final destination delivery.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/real-time-tracking.svg',
        alt: 'Real-Time Tracking service'
      }
    },
    {
      id: 5,
      title: 'Eco-Friendly Solutions',
      description: 'Our packaging options and logistics are designed with sustainability in mind.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/eco-friendly-solutions.svg',
        alt: 'Eco-Friendly Solutions service'
      }
    },
    {
      id: 6,
      title: 'Safe and Secure',
      description: 'We ensure safe, secure, and careful handling of your boxes throughout the journey.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/safe-and-secure.svg',
        alt: 'Safe and Secure service'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Packing and Labeling Guidelines',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Ship Your Box Today' },

  articles: [
    {
      content: [
        {
          title: 'How to Pack Your Boxes',
          points: [
            'Use sturdy, double-walled cardboard or plastic shipping boxes.',
            'Tape the top and bottom of the box using the "H" method for extra security.',
            'Choose the correct box size and avoid overloading or exceeding weight limits.',
            'Protect and secure fragile or uninsured items properly.',
            'Do not include prohibited items in your shipment.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/how-to-pack-your-boxes.png',
        alt: 'How to Pack Your Boxes'
      }
    },
    {
      content: [
        {
          title: 'How to Label Your Boxes',
          points: [
            'Place the shipping label inside a secure label pouch, barcode facing outward.',
            'Attach the pouch firmly to the side of the box, avoiding seams or openings.',
            'Add an extra copy of the label inside the box for identification.',
            'Take a photo of the labeled box, ensuring the tracking barcode is visible.'
          ]
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/how-to-label-your-boxes.png',
        alt: 'Prepare Your Items feature'
      }
    }
  ]
}

export const boxSizesAndLimitsSectionContent = {
  title: 'Box Sizes and Limits',

  cards: [
    {
      id: 1,
      title: 'Small Box',
      points: [
        '<strong>Maximum Weight:</strong> 25 lbs (11 kg)',
        '<strong>Maximum Length:</strong> 15 in (38 cm)',
        '<strong>Maximum Girth:</strong> 60 in (152 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/small-box.png',
        alt: 'Small Box'
      }
    },
    {
      id: 2,
      title: 'Medium Box',
      points: [
        '<strong>Maximum Weight:</strong> 42 lbs (19 kg)',
        '<strong>Maximum Length:</strong> 18 in (46 cm)',
        '<strong>Maximum Girth:</strong> 72 in (183 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/medium-box.png',
        alt: 'Medium Box'
      }
    },
    {
      id: 3,
      title: 'Large Box',
      points: [
        '<strong>Maximum Weight:</strong> 60 lbs (27 kg)',
        '<strong>Maximum Length:</strong> 20 in (51 cm)',
        '<strong>Maximum Girth:</strong> 80 in (204 cm)'
      ],
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/large-box.png',
        alt: 'Large Box'
      }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'What Can You Ship with Us?',

  cards: [
    {
      id: 1,
      title: 'Household Items',
      description: 'Move clothes, kitchenware, decor, and more with peace of mind.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/household-items.svg',
        alt: 'Household Items service'
      }
    },
    {
      id: 2,
      title: 'Books and Documents',
      description: 'Securely ship personal or professional materials, no matter the weight.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/books-and-documents.svg',
        alt: 'Books and Documents service'
      }
    },
    {
      id: 3,
      title: 'Electronics and Gadgets',
      description: 'Protect sensitive items like laptops, TVs, and gaming consoles during transit.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/electronics-and-gadgets.svg',
        alt: 'Electronics and Gadgets service'
      }
    },
    {
      id: 4,
      title: 'Seasonal Items',
      description: 'Perfect for holiday decorations, sports equipment, or unique collections.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/seasonal-items.svg',
        alt: 'Seasonal Items service'
      }
    },
    {
      id: 5,
      title: 'Dorm Room Essentials',
      description: 'Simplify college moves by shipping student necessities directly to the dorm.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/dorm-room-essentials.svg',
        alt: 'Dorm Room Essentials service'
      }
    },
    {
      id: 6,
      title: 'Business Supplies',
      description: 'Move inventory, tools, or office essentials with our tailored services.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/business-supplies.svg',
        alt: 'Business Supplies service'
      }
    }
  ]
}

export const whoCanBenefitSectionContent = {
  title: 'Who Can Benefit from Our Moving Box Shipping Service?',

  cards: [
    {
      id: 1,
      title: 'Home Movers',
      description:
        'Make moving day stress-free by shipping household items directly to your new address, ensuring  seamless relocation.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/home-movers.svg',
        alt: 'Home Movers service'
      }
    },
    {
      id: 2,
      title: 'Students',
      description:
        'Simplify moves to and from campus with convenient shipping options for dorm essentials, personal belongings, etc. ',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/students.svg',
        alt: 'Students service'
      }
    },
    {
      id: 3,
      title: 'International Movers',
      description:
        'Relocate anywhere in the world effortlessly with our trusted global shipping services, tailored for long-distance transitions.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/international-movers.svg',
        alt: 'International Movers service'
      }
    },
    {
      id: 4,
      title: 'Business Professionals',
      description:
        'Safely ship office supplies, documents, & inventory to meet professional needs, whether for work travel or relocation.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/business-professionals.svg',
        alt: 'Business Professionals service'
      }
    },

    {
      id: 5,
      title: 'Military Families',
      description:
        'Rely on us for dependable and quick moves, offering secure shipping solutions for frequent relocations and urgent schedules.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/military-families.svg',
        alt: 'Military Families service'
      }
    },
    {
      id: 6,
      title: 'Vacation Home Owners',
      description:
        'Ship seasonal items like clothing, sports gear, and supplies to your getaway destination, making trips convenient.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/vacation-home-owners.svg',
        alt: 'Vacation Home Owners service'
      }
    },
    {
      id: 7,
      title: 'Digital Nomads',
      description:
        'Travel light by shipping your essentials ahead to your next destination, allowing you to focus on work and enjoy the journey.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/digital-nomads.svg',
        alt: 'Digital Nomads service'
      }
    },
    {
      id: 8,
      title: 'Event Planners',
      description:
        'Send decorations, supplies, and event materials directly to the venue, ensuring a smooth setup and smooth coordination.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/event-planners.svg',
        alt: 'Event Planners service'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Packing Tips for Moving Box Shipping',

  cards: [
    {
      id: 1,
      title: 'Choose Durable Boxes',
      description:
        'Use sturdy, high-quality boxes made from double-walled cardboard or durable plastic. These materials provide better protection during transit, reducing the risk of damage.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/choose-durable-boxes.svg',
        alt: 'Choose Durable Boxes service'
      }
    },
    {
      id: 2,
      title: 'Label Clearly',
      description:
        'Clearly mark the contents and destination on each box. Use a permanent marker or printable labels to ensure visibility, and include both sender and receiver information. ',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/label-clearly.svg',
        alt: 'Label Clearly service'
      }
    },
    {
      id: 3,
      title: 'Wrap Fragile Items',
      description:
        "Wrap breakable items in bubble wrap and place them in the box's center. Fill empty spaces with packing peanuts or crumpled paper to minimize movement.",
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/wrap-fragile-items.svg',
        alt: 'Wrap Fragile Items service'
      }
    },
    {
      id: 4,
      title: 'Seal Boxes Properly',
      description:
        'Securely tape all seams and edges of the box using strong packing tape. Apply multiple layers of tape to the bottom and top flaps to prevent accidental openings during transit.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/seal-boxes-properly.svg',
        alt: 'Seal Boxes Properly service'
      }
    },
    {
      id: 5,
      title: 'Avoid Over packing',
      description:
        'Distribute the weight evenly across all boxes. Over packing can lead to tears or damage, while uneven weight makes handling and stacking more difficult for carriers.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/avoid-over-packing.svg',
        alt: 'Avoid Over packing service'
      }
    },
    {
      id: 6,
      title: 'Include Contact Info',
      description:
        'Insert a sheet with your contact information and destination address inside each box to ensure proper identification and redirection if the external label is lost or damaged.',
      image: {
        src: '/images/v2/pages/main-pages/moving-box-shipping/include-contact-info.svg',
        alt: 'Include Contact Info service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Start Your Move with ShipAndStorage Today',
  description:
    'Don’t let the stress of moving weigh you down. Ship your boxes with ShipAndStorage and enjoy a smooth, hassle-free relocation. Whether it’s across town or across the globe, we’ll handle your moving box shipping with care, precision, and professionalism.',
  image: {
    src: '/images/v2/pages/main-pages/moving-box-shipping/promotional-banner-image.svg',
    alt: 'Start Your Move with ShipAndStorage Today'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Start Shipping' }
}

export const faqSectionContent = {
  title: 'FAQs About Moving Box Shipping',

  questions: [
    {
      id: 1,
      question: 'What is the maximum box size I can ship?',
      answer: 'We handle boxes of various sizes. Check our guidelines for specific dimensions and weight limits.'
    },
    {
      id: 2,
      question: 'How long does delivery take?',
      answer: 'Delivery times depend on the destination but typically range from 2-10 business days.'
    },
    {
      id: 3,
      question: 'Can I insure my shipment?',
      answer: 'Yes, we offer optional insurance for added protection of your items.'
    },
    {
      id: 4,
      question: 'What items are restricted?',
      answer: 'Check our prohibited items list for details to ensure smooth transit.'
    },
    {
      id: 5,
      question: 'Do you offer discounts for bulk shipments?',
      answer: 'Yes, contact us for custom pricing on larger moves.'
    }
  ]
}
